import React, { useEffect } from 'react'
import styled from 'styled-components'
import FormPanel from '@src/components/FormPanel/FormPanel'
import FormPAETable, { PAETableRowType } from '@src/components/Form/PAETable'
import DRSMaterialSpraySealOtherFields, { DRSMaterialSpraySealOtherRowDisplay } from './MaterialSpraySealOtherFields'
import useModal from '@src/components/FormModal/useModal'
import { useSnackbar } from '@src/components/GlobalSnackbar'
import { DRSPageType, DRSSectionName } from '@src/modules/DRS/DRSPage'
import MarginTop from '@src/components/Layout/MarginTop'
import CompCreateButton from '@src/components/Buttons/CreateButton'
import { useDRS } from '@src/modules/DRS/useDRS'
import Modal from '@src/components/FormModal/Modal'
import { useAppStore } from '@src/AppStore'
import _get from 'lodash/get'
import { doubleUp } from '@src/modules/DRS/utils/doubleUp'
import { PAE } from '@src/types/drs/PAE'
import { genericUpdateDRSSection } from '@src/modules/DRS/utils/genericUpdateDRSSection'
import { mapMoreActions } from '@src/modules/DRS/utils/mapMoreActions'

interface DRSMaterialSpraySealOtherRow extends DRSMaterialSpraySealOtherRowDisplay {
  _key_: string,
  _type_: PAETableRowType,
  _no_?: number,
  _editable_: boolean,
}

const NULL_VALUES = {
  catEyeCovers: null,
  emulsion: null,
  geoFabric: null,
  grit: null,
  hateliteBitac: null,
  sticksNStomps: null,
  depot: null,
}
const ZERO_VALUES = {
  catEyeCovers: '0',
  emulsion: '0',
  geoFabric: '0',
  grit: '0',
  hateliteBitac: '0',
  sticksNStomps: '0',
  depot: null,
}

interface Props { refreshTrigger?: number }
const DRSSectionMaterialSpraySealtOthers = (props: Props) => {
  const { refreshTrigger } = props
  const { drs, updateSectionViaPath, drsPageType, refresh } = useDRS()
  const isPlan = drsPageType === DRSPageType.Plan
  const isEdit = drsPageType === DRSPageType.Edit
  const updatingColumn: PAE.Plan | PAE.Edit = isPlan ? PAE.Plan : PAE.Edit
  const { alertError, alertDone } = useSnackbar()
  const [open, modalData, openAndSetData, closeModal] = useModal<DRSMaterialSpraySealOtherRow>({})
  const { depotId, stateId } = useAppStore()

  // refresh if showing in ShiftDialig to show first record when first record has been created in MaterialAsphaltItems
  useEffect(() => {
    if (refreshTrigger) {
      refresh()
    }
  }, [refreshTrigger])
  if (drs === null) {
    return null
  }
  const onSave = async (form: DRSMaterialSpraySealOtherRow) => {
    if (modalData === null) {
      addOther(form)
    } else {
      EditOther(form)
    }
  }
  const addOther = (form: DRSMaterialSpraySealOtherRow) => {
    updateItemByValues(form, form)
  }
  const EditOther = (form: DRSMaterialSpraySealOtherRow) => {
    updateItemByValues(form, form)
  }
  const handleRevert = (form: DRSMaterialSpraySealOtherRow) => {
    updateItemByValues(form, NULL_VALUES)
  }
  const handleMarkZero = (form: DRSMaterialSpraySealOtherRow) => {
    updateItemByValues(form, ZERO_VALUES)
  }
  const updateItemByValues = (form: DRSMaterialSpraySealOtherRow, values: any) => {
    const retained = drs.material.spraySeal.summary
    const data = {
      ...retained,
      [updatingColumn]: {
        ...values,
      },
    }
    update(data)
  }
  const update = (data: any) => {
    genericUpdateDRSSection({
      sectionName: DRSSectionName.Material,
      path: `spraySeal.summary`,
      data,
      refresh,
      closeModal,
      alertDone,
      alertError,
      updateSectionViaPath,
    })
  }
  const getTableData = () => {
    const other = drs.material.spraySeal.summary
    const others = [...(other === null ? [] : [other])]
    if (!others || !others.length) {
      return []
    }
    const doubled = doubleUp(others, drsPageType)
    const doubledWithActions = doubled.map((data: any) => mapMoreActions(data, drsPageType))
    return doubledWithActions
  }
  return <Wrapper>
    <FormPanel title={`Material Spray Seal Other`}>
      <FormPAETable<DRSMaterialSpraySealOtherRow>
        fields={DRSMaterialSpraySealOtherFields}
        data={getTableData()}
        editable={true}
        onEditRow={(row: DRSMaterialSpraySealOtherRow) => {
          openAndSetData(row)
        }}
        showMoreActions={isEdit}
        onRevert={handleRevert}
        onMarkZero={handleMarkZero}
        isSelectable={true}
      />
      {(isPlan || isEdit) && !getTableData().length &&
        <MarginTop>
          <CompCreateButton onClick={() => {
            openAndSetData(null)
          }}>
            Add Other Spray Seal Material
          </CompCreateButton>
        </MarginTop>
      }
    </FormPanel>

    {open &&
      <Modal<DRSMaterialSpraySealOtherRow>
        maxWidth={'sm'}
        open={open}
        title='Material'
        data={{
          rowData: modalData,
          fields: DRSMaterialSpraySealOtherFields,
          columns: [
            {
              title: 'Material Information',
              fieldKeys: [
                'catEyeCovers',
                'depot',
                'emulsion',
                'geoFabric',
              ],
            },
            {
              title: '',
              fieldKeys: [
                'grit',
                'hateliteBitac',
                'sticksNStomps',
              ],
            },
          ],
          extra: {
            depotId,
            stateId,
          }
        }}
        onSuccess={onSave}
        onClose={closeModal}
        onCancel={closeModal}
      />
    }
  </Wrapper>
}

const Wrapper = styled.div`

`

export default DRSSectionMaterialSpraySealtOthers